/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Hero_TitleInputs */

const en_dr_hero_title = /** @type {(inputs: Dr_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agree. Plan. Prove. Ship.`)
};

const id_dr_hero_title = /** @type {(inputs: Dr_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sepakati. Rencanakan. Buktikan. Rilis.`)
};

/**
* | output |
* | --- |
* | "Agree. Plan. Prove. Ship." |
*
* @param {Dr_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_hero_title = /** @type {((inputs?: Dr_Hero_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Hero_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_hero_title(inputs)
	return en_dr_hero_title(inputs)
});